// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.amex-offer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  padding: 0 12px;
  background: #ffffff;
  border: none;
  border-radius: 6px;
  color: #000000;
  font-family: AppFontEintrachtSansOFCBold;
  font-size: 14px;
  line-height: 130%;
  letter-spacing: 0;
  cursor: pointer;
  transition: background-color 120ms ease-out;
}
.amex-offer-btn:active {
  background: #e6e6e6;
}
.amex-offer-btn:focus-visible {
  outline: 2px solid var(--ion-color-eintracht-red);
  outline-offset: 2px;
}
.amex-offer-btn .info-icon {
  align-self: flex-start;
  margin-top: 11px;
  margin-left: 1px;
  font-size: 8px;
}

:host(.large) .amex-offer-btn {
  height: 50px;
  font-size: 16px;
}
:host(.large) .amex-offer-btn .info-icon {
  margin-top: 15px;
  font-size: 9px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/amex-offer-button/amex-offer-button.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,2CAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,iDAAA;EACA,mBAAA;AAAJ;AAGE;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AADJ;;AAMA;EACE,YAAA;EACA,eAAA;AAHF;AAKE;EACE,gBAAA;EACA,cAAA;AAHJ","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n}\n\n.amex-offer-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 40px;\n  padding: 0 12px;\n  background: #ffffff;\n  border: none;\n  border-radius: 6px;\n  color: #000000;\n  font-family: AppFontEintrachtSansOFCBold;\n  font-size: 14px;\n  line-height: 130%;\n  letter-spacing: 0;\n  cursor: pointer;\n  transition: background-color 120ms ease-out;\n\n  &:active {\n    background: #e6e6e6;\n  }\n\n  &:focus-visible {\n    outline: 2px solid var(--ion-color-eintracht-red);\n    outline-offset: 2px;\n  }\n\n  .info-icon {\n    align-self: flex-start;\n    margin-top: 11px;\n    margin-left: 1px;\n    font-size: 8px;\n  }\n}\n\n// Cart footer variant (Warenkorb): 50px tall, 16px label\n:host(.large) .amex-offer-btn {\n  height: 50px;\n  font-size: 16px;\n\n  .info-icon {\n    margin-top: 15px;\n    font-size: 9px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
